import { prepareArtwork, requireDeviceProfileId, Orientation } from "./authoring.js";

export function mountUsbBranding(host, { client, branding, run, status, isCurrent }) {
  host.innerHTML = `<h3>Startup logo</h3><p data-logo-target></p><div data-logo-preview></div>
    <button class="button" data-logo-prepare>Preview on this Pirdy</button>
    <label><input type="checkbox" data-logo-confirm /> Change only the connected Pirdy's startup logo.</label>
    <button class="button primary" data-logo-apply>${branding.remove ? "Restore Pirdy logo" : "Set startup logo"}</button>`;
  const select = selector => host.querySelector(selector);
  let prepared, preparedDevice;
  if (branding.remove) select("[data-logo-prepare]").hidden = true;
  select("[data-logo-prepare]").onclick = () => run(async () => {
    const device = client.device;
    if (!device || !branding.source) throw new Error("Connect a Pirdy and choose a PNG or JPEG first.");
    const profile = requireDeviceProfileId(device.hardwareProfile), value = String(device.orientation).toLowerCase();
    const orientation = value === "landscape" ? Orientation.landscape : value === "portrait" ? Orientation.portrait : null;
    if (!orientation) throw new Error("The Pirdy screen orientation is unknown.");
    const result = await prepareArtwork(branding.source, "fit", orientation, "#fff", profile);
    if (!isCurrent() || client.device !== device) return;
    prepared = result;preparedDevice = device;
    const preview = document.createElement("img");preview.src = result.previewUrl;
    preview.alt = "Complete startup logo fitted to the connected Pirdy";preview.style.maxWidth = "100%";
    select("[data-logo-preview]").replaceChildren(preview);
    select("[data-logo-target]").textContent = `${device.deviceId}: ${result.metadata.width} × ${result.metadata.height}`;
    select("[data-logo-confirm]").checked = false;
    status("Preview prepared locally. Review the complete logo and confirm before applying.");
  });
  select("[data-logo-apply]").onclick = () => run(async () => {
    if (!select("[data-logo-confirm]").checked) throw new Error("Confirm changing this Pirdy's startup logo first.");
    if (branding.remove) {
      const result = await client.request(26);
      if (!isCurrent()) return;
      if (result.customBranding !== false || result.appliesOnNextStartup !== true) throw new Error("Removing the logo was not confirmed. Refresh before retrying.");
    } else {
      if (!prepared || preparedDevice !== client.device) throw new Error("Preview the logo on this Pirdy before applying.");
      const bytes = new Uint8Array(await prepared.blob.arrayBuffer());
      await client.purpose("storage");
      try {
        const storage = await client.request(3);
        if (!storage.available || storage.freeBytes < bytes.length + 65536) throw new Error("The microSD card is unavailable or full.");
        await client.upload("/branding/active.pimg", bytes, isCurrent,
          (done, total) => status(`Sending startup logo: ${Math.round(done * 100 / total)}%`));
      } finally { bytes.fill(0);if (!client.faulted && isCurrent()) await client.purpose("control"); }
    }
    if (isCurrent()) status("Startup logo change verified on this Pirdy. It applies at next startup.");
  });
}
